
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { Mail, Send } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { useAnalytics } from "@/hooks/use-analytics";

export const EmailForwardCard = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const { trackEvent } = useAnalytics();

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('trips@checkmytrip.com');
    trackEvent('NewTrip', 'copy_forwarding_email', 'trips@checkmytrip.com');
    toast({
      title: t("common.toast.copied"),
      description: t("newTrip.emailCopiedDesc"),
    });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("newTrip.emailForward")}</CardTitle>
        <CardDescription>{t("newTrip.emailForwardDesc")}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center space-x-2 bg-muted p-4 rounded-lg">
          <Mail className="h-5 w-5 text-muted-foreground" />
          <span className="text-sm font-mono">trips@checkmytrip.com</span>
        </div>
        <Button 
          variant="outline" 
          className="w-full" 
          onClick={handleCopyEmail}
        >
          <Send className="mr-2 h-4 w-4" />
          {t("newTrip.copyEmail")}
        </Button>
      </CardContent>
    </Card>
  );
};
